import { Card, Empty, Table, Tag, Tooltip } from "antd";
import { useMemo } from "react";
import { PROMO_TOOLTIPS } from "../../utils/constants";
import { formatarMoeda, formatarPct } from "../collections-change/promoHelpers";
import { linhasDosSkus } from "./eventoHelpers";

const formatarQuantidade = (valor) =>
  typeof valor === "number"
    ? valor.toLocaleString("pt-BR", { maximumFractionDigits: 2 })
    : "—";

const COLUNAS = [
  { title: "SKU", dataIndex: "produto", key: "produto", width: 110 },
  {
    title: "Descrição",
    dataIndex: "descricao",
    key: "descricao",
    render: (descricao) => descricao || "—",
  },
  {
    title: (
      <Tooltip title={PROMO_TOOLTIPS.desconto_permanente_pct}>
        Desc. permanente
      </Tooltip>
    ),
    key: "desconto_permanente_pct",
    width: 130,
    render: (_, linha) =>
      typeof linha.desconto_permanente_pct === "number" &&
      linha.desconto_permanente_pct > 0 ? (
        <Tag>{formatarPct(linha.desconto_permanente_pct)}</Tag>
      ) : (
        "—"
      ),
  },
  {
    title: "Unidades",
    dataIndex: "unidades",
    key: "unidades",
    align: "right",
    width: 100,
    render: formatarQuantidade,
  },
  {
    title: "Vendas",
    dataIndex: "vendas",
    key: "vendas",
    align: "right",
    width: 90,
    render: formatarQuantidade,
  },
  {
    title: "Faturamento",
    dataIndex: "faturamento",
    key: "faturamento",
    align: "right",
    width: 140,
    render: formatarMoeda,
  },
  {
    title: "Ticket médio",
    dataIndex: "ticket_medio",
    key: "ticket_medio",
    align: "right",
    width: 130,
    render: formatarMoeda,
  },
];

export default function EventoSkusCard({ grupos, isLoading }) {
  const linhas = useMemo(() => linhasDosSkus(grupos), [grupos]);

  return (
    <Card
      title="Faturamento por SKU do evento"
      loading={isLoading}
      style={{ width: "85%", maxWidth: "100%" }}
      styles={{ header: { backgroundColor: "var(--ouran-card-header-bg)" } }}>
      {linhas.length === 0 ? (
        <Empty description="Nenhuma venda dos SKUs do evento no período." />
      ) : (
        <Table
          rowKey="produto"
          size="small"
          columns={COLUNAS}
          dataSource={linhas}
          pagination={{ pageSize: 10, hideOnSinglePage: true }}
          scroll={{ x: 800 }}
        />
      )}
    </Card>
  );
}
